import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import AverageCorrectAnswers from "../components/AverageCorrectAnswers";
import CorrectVsIncorrectByMonth from "../components/CorrectVsIncorrectByMonth";
import MathCard from "../components/MathCard";
import NewMathCard from "../components/NewMathCard";
import ReadingAndWritingCard from "../components/ReadingAndWritingCard";
import ReadingCard from "../components/ReadingCard";
import TopTesters from "../components/TopTesters";
import WritingCard from "../components/WritingCard";
import { AnalyticsProvider } from "../hooks/useAnalyticsData";
import theme from "@shared/utils/themeColors";

const Dashboard: React.FC = () => {
  return (
    <AnalyticsProvider>
      <AuthenticatedLayout>
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
          {/* Dashboard actions */}
          <div className="sm:flex sm:justify-between sm:items-center mb-8">
            {/* Left: Title */}
            <div className="mb-4 sm:mb-0">
              <h1 className={`text-2xl md:text-3xl ${theme.text.primary} font-bold`}>
                Performance
              </h1>
            </div>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-12 gap-6">
            {/* Section Performance Cards */}
            <ReadingAndWritingCard />
            <NewMathCard />
            <ReadingCard />
            <WritingCard />
            <MathCard />
            <CorrectVsIncorrectByMonth />
            <AverageCorrectAnswers />
            <TopTesters />
            {/* <RecentActivity /> */}
          </div>
        </div>
      </AuthenticatedLayout>
    </AnalyticsProvider>
  );
};

export default Dashboard;
